import { useQuery } from '@tanstack/react-query'

import api from '../../api'

const useAllAdGroups = () => {
	return useQuery({
		queryKey: ['AllAdGroups'],
		queryFn: api.activeDirectory.getAllAdGroups
	})
}

export default useAllAdGroups
